export enum PeriodCategory {
  Today = 'Today',
  ThisWeek = 'This week',
  OverAWeek = 'Over a week'
}
